export default __webpack_public_path__ + "static/media/playstore.9ded7b3a.png";